import { combineReducers } from 'redux';

import hotelsReducer from './hotelsReducer';
import tabsReducer from './tabsReducer';
import selectSuggestionReducer from './selectSuggestionReducer';

const rootReducer = combineReducers({
    hotelsRedux: hotelsReducer,
    tabsRedux: tabsReducer,
    selectSuggestionRedux:selectSuggestionReducer
});

export default rootReducer;


// WEBPACK FOOTER //
// ./src/reducers/index.js